import { ready } from '../utils/ready';
import imagemap from './imagemap';
import definitions from './definitions';
import hoverVideo from './hoverVideo';

// Story pages (loaded on singular pages after app.js).
ready(() => {
    imagemap();
    definitions();
    hoverVideo();
});
